import React, { HTMLAttributes, ReactNode } from 'react';

interface MasonryGridProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  items: ReactNode[];
}

import './style.scss';

const MasonryGrid: React.FC<MasonryGridProps> = ({ items }) => (
  items.length === 2 ? (
    <div className="MasonryGrid two row">
      <div className="left col-md-6">
        {items[0]}
      </div>
      <div className="right col-md-6">
        {items[1]}
      </div>
    </div>
  ) : (
    <div className="MasonryGrid four row">
      <div className="left col-md-6">
        {items[0]}
        {items[2]}
      </div>
      <div className="right col-md-6">
        {items[1]}
        {items[3]}
      </div>
    </div>
  )
);

export default MasonryGrid;
